import React, { useState } from 'react';
import MaterialInput from 'screens/Registration/elements/MaterialInput/MaterialInput';
import PropTypes from 'prop-types';
import EyeClose from 'assets/images/general/eye-close.svg';
import GrayEye from 'assets/images/general/grayEye.svg';
import './NewLoginScreen.scss';
import ActivityIndicator from 'creatella-react-components/lib/ActivityIndicator';
import { ROUTES } from 'config/constants';
import { MobileView } from 'react-device-detect';
import CautionIcon from 'assets/images/general/warning.svg';
import usePageDetails from 'hooks/usePageDetails';
import BackgroundVideo from './BackgroundVideo';
import GoolePlay from 'assets/images/general/google-play.png';
import Appstore from 'assets/images/general/apple-logo.png';

NewLoginScreen.propTypes = {
    onLogin: PropTypes.func.isRequired,
    handleForm: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    isAuthenticating: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    apiCaller: PropTypes.func
};

function NewLoginScreen({
    onLogin,
    handleForm,
    form,
    isAuthenticating,
    history,
    apiCaller
}) {
    const page = usePageDetails(apiCaller);

    const [type, setType] = useState(false);

    const handleSubmit = e => {
        e.preventDefault();
        onLogin();
    };

    return (
        <div className='login'>
            <BackgroundVideo />
            <div className='login__form'>
                <div className='newloginForm' style={{ display: !page.data?.data && page.isFetching ? 'none' : 'block' }}>
                    <div className='loginForm__logo'>
                        <img src={page.logo} alt='logo' className='backgroundLogo' />
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className='loginForm__form'>
                            <div className='loginFormRow'>
                                <MaterialInput
                                    // wrapperClassName='inputWrapper'
                                    label='Email or Username'
                                    value={form.email}
                                    onChange={e => handleForm({ ...form, email: e })}/>
                            </div>
                            <div>
                                <MaterialInput
                                    // wrapperClassName='inputWrapper'
                                    value={form.password}
                                    onChange={e => handleForm({ ...form, password: e })}
                                    type={!type ? 'password' : 'text'}
                                    onIconClick={() => setType(!type)}
                                    label='Password'
                                    icon={type ? GrayEye : EyeClose}/>
                            </div>
                            <div>
                                <div className='forgot' onClick={() => history.push(ROUTES.RECOVER_PASSWORD)}>Forgot Password?</div>
                            </div>
                            <div>

                                <button
                                    className='loginBtn'
                                    type='submit'
                                    disabled={isAuthenticating}>
                                    {isAuthenticating
                                        ? <ActivityIndicator />
                                        : 'ACCESS MARKETPLACE'
                                    }
                                </button>
                            </div>
                            <div>
                                <div className='notRemember' onClick={() => history.push(ROUTES.SIGN_UP)}>Not a member? Sign Up</div>
                            </div>

                            <div className='newloginForm__storeCtaCtainer'>
                                <a href='https://play.google.com/store/apps/details?id=com.papertrader.app' target='_blank' rel='noreferrer'><img src={GoolePlay} alt='tick' className='newloginForm__storeCtaCtainer__storeCta'/></a>
                                <a href='https://apps.apple.com/us/app/papertrader/id1576180196' target='_blank' rel='noreferrer'><img src={Appstore} alt='tick' className='newloginForm__storeCtaCtainer__storeCta'/></a>
                            </div>
                        </div>
                    </form>
                </div>
                <MobileView>
                    <div className='login__mobile-alert'>
                        <img className='login__caution-img' src={CautionIcon} alt='current usage' />

                Dear user,
                        <br />
                Please use a desktop/laptop for a better user experience. This application is designed for large dimension screens.
                    </div>
                </MobileView>
            </div>
            {/* <div className='login__img'>
                <img src={Login} alt='back' className='backgroundImg' />
            </div> */}
        </div>
    )
    ;
}

export default NewLoginScreen;
